import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { modules } from '../data/content';
export function Modules() {
  return <section aria-label="Included modules" className="bg-mist px-3 py-4 sm:px-6" data-id="element-107" data-mp="1r4sov7zfhav5">
      <div className="mx-auto max-w-2xl space-y-2" data-id="element-108" data-mp="1vy3nwmy00nci">
        {modules.map(mod => <article key={mod.number} className="overflow-hidden rounded-md border border-navy/10 bg-white shadow-sm" data-id="element-109" data-mp="20wever0tmlrk">
            <div className="flex items-center gap-1.5 border-l-4 border-clinical bg-navy px-2.5 py-1.5" data-id="element-110" data-mp="1477l6f5njz2y">
              <CheckCircle2Icon className="h-3.5 w-3.5 shrink-0 text-gold" strokeWidth={2.5} aria-hidden="true" data-id="element-111" data-mp="1889dsd52dcvy" />
              <h3 className="font-heading text-[0.7rem] font-extrabold uppercase leading-tight tracking-wide text-white sm:text-[0.88rem]" data-id="element-112" data-mp="1d59fycyslvhs">
                MODULE {mod.number} — {mod.title}
              </h3>
            </div>
            <p className="px-2.5 py-2 text-[0.78rem] leading-[1.35] sm:text-[0.92rem]" data-id="element-113" data-mp="2tku99a87uy1b">{mod.body}</p>
          </article>)}
      </div>
    </section>;
}